import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import {HashLink} from 'react-router-hash-link';


class Heroine extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="Heroin" />
            <div className="container" style={{marginTop:"60px"}}>
            <HashLink to='/faq#heroine'>
                <button id="myBtn" title="FAQ">
                <i class="fas fa-info-circle faqicon"></i> 
                    <p>  FAQ</p>
                </button>
                </HashLink>
                
                <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationHeroine.png" alt="heroin">
                        </img>
                        
                        </div>
                    </div>

                <div className="content">
                    <h4>What are Opioids? (includes Heroin, Prescription Opioids, Poppy)</h4>
                    <p>Opioids are a class of drugs that act in the nervous system to <b>produce feelings of pain relief and pleasure (“rush”)</b>. All opioids are chemically related and are considered safe when prescribed for a short period of time. However, because they produce euphoria along with pain relief, the <b>chance of misuse and abuse is high</b>. Regular opioid use can use to tolerance and addiction.</p>

                    <p>Some opioids <b>may be legally prescribed</b> by healthcare providers such as oxycodone, fentanyl, tramadol, or morphine. Other opioids, like <b>heroin, are illegal</b>. Opium poppy and opium gum can be legally produced in India. The <b>cultivation of opium plant</b> for medical and scientific purposes is <b>permitted and regulated by the Central Government</b> under the NDPS Act. Licenses are issued to farmers for the cultivation, and Central Bureau of Narcotics ensures that conditions are followed.</p>

                    
                    <h2>Heroin</h2>
                    <p> Heroin is an <b>opioid drug made from morphine</b>, which is a natural substance taken from the seeds 
                        of poppy plants. It can be in the form of <b>white/brown powder or a black sticky substance </b>(black tar heroin). 
                        Heroin can be ingested by smoking, snorting, sniffing, or injecting.</p>
                    
                    <p>Common street names include smack, brown sugar, H, or hell dust. A mixture of heroin
                         with crack cocaine is known as <b>“speedball”</b> and 
                        is extremely dangerous due to the <b>highly addictive</b> qualities of both the drugs.</p>
                    
                    <p>Heroin enters the brain rapidly and binds itself to opioid receptors which are involved in 
                        <b>feelings of pain and pleasure</b>, and controlling heart rate, sleeping and breathing. 
                        Long term opioid use can also lead to <b>loss in the brain's white matter</b> that can affect
                         decision-making, behaviour control, and responses to stress. It is highly addictive, and 
                         regular users often <b>develop tolerance</b> (need more high and frequent doses to get the same 
                         “high”). Heroin addiction can have <b>severe 
                        withdrawal</b> that can begin in a few hours after the drug was last taken. Symptoms include-</p>

                    <ul>
                        <li><p>Restlessness</p></li>
                        <li><p>Severe muscle and bone pain</p></li>
                        <li><p>Sleep problems</p></li>
                        <li><p>Diarrhea and vomiting</p></li>
                        <li><p>Cold flashes with goosebumps (“cold turkey”)</p></li>
                        <li><p>Uncontrollable leg movements</p></li>
                        <li><p>Severe heroin cravings</p></li>
                    </ul>

                    <h4>Short term effects include- </h4>
                    <ul>
                        <li><p>Feeling a “rush”, surge of euphoria</p></li>
                        <li><p>Dry mouth</p></li>
                        <li><p>Warm flushing of skin</p></li>
                        <li><p>Heavy feeling in limbs</p></li>
                        <li><p>Nausea and vomiting</p></li>
                        <li><p>Severe itching</p></li>
                        <li><p>Clouded mental functioning</p></li>
                        <li><p>Slipping between semi-conscious and conscious states</p></li>
                    </ul>

                    <h4>Long term effects include- </h4>
                    <ul>
                        <li><p>Insomnia</p></li>
                        <li><p>Collapsed vein (in case of injecting)</p></li>
                        <li><p>Damaged tissue in the nose (in case of snorting or sniffing)</p></li>
                        <li><p>Infection in heart lining or valves</p></li>
                        <li><p>Abscesses</p></li>
                        <li><p>Constipation, stomach cramps</p></li>
                        <li><p>Liver, kidney damage</p></li>
                        <li><p>Lung diseases like pneumonia</p></li>
                        <li><p>Sexual dysfunction in men</p></li>
                        <li><p>Irregular menstrual cycles in women</p></li>
                        <li><p>Additives like sugar, starch, powder, and powdered milk can clog blood vessels- causing permanent damage. </p></li>
                        <li><p>Higher risk of HIV, hepatitis C (in case of injecting)</p></li>
                    
                    </ul>
                    <p>Heroin overdoses can occur when a person uses enough drug to produce a 
                        life-threatening reaction or death. When people overdose on heroin, their 
                        breathing often slows or stops which <b>decreases the amount of oxygen reaching 
                        the brain (hypoxia)</b>. It has short and long term mental effects on 
                        the nervous system, including <b>coma and permanent brain damage</b>.</p>

        
                </div>
            </div>
            </div>
        )
    }
}

export default Heroine;